// extracted by mini-css-extract-plugin
module.exports = {"root":"MedicalHistory_root__r_g8R"};